module.exports = __webpack_public_path__ + "static/media/marketcrm.3b00e29b.png";